//packing list
const PackingList = () => import("Modules/manufacturing/packing_lists/views/PackingList");
const PackingListProfile = () => import("Modules/manufacturing/packing_lists/views/PackingListProfile");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "packing_lists",
            name: "packing_lists",
            component: PackingList,
            meta: {
                requiresAuth: true,
                title: "lang.packing_lists",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["packing_lists.read"],
            },
        },
        {
            path: "packing_lists/:id(\\d+)",
            name: "packing_list_profile",
            component: PackingListProfile,
            meta: {
                requiresAuth: true,
                title: "lang.packing_list",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["packing_lists.read"],
            },
        },
    ],
};
